var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _path7, _path8, _g3, _path9, _g4, _path10, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsa2Logo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 12,
    viewBox: "0 0 180 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.61877 8.07136C1.61877 8.34104 1.70867 8.57152 1.88846 8.76311C2.06856 8.9547 2.28485 9.0505 2.53793 9.0505H12.4618C12.7146 9.0505 12.9311 8.9547 13.1109 8.76311C13.291 8.57152 13.3809 8.34104 13.3809 8.07136V0.775757H15V8.07136C15 8.82002 14.7526 9.45802 14.258 9.98505C13.7631 10.5121 13.1643 10.7758 12.4618 10.7758H2.53793C1.83506 10.7758 1.23662 10.5121 0.742034 9.98505C0.247147 9.45802 0 8.82002 0 8.07136V0.775757H1.61877V8.07136Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7445 2.49944H19.7838C19.6702 2.50544 19.5624 2.52028 19.4603 2.54429C19.3186 2.5803 19.1907 2.634 19.0771 2.70601C18.7824 2.90943 18.6344 3.24141 18.6344 3.70225C18.6344 3.82197 18.6485 3.93568 18.6772 4.04339C18.7057 4.19911 18.7566 4.33367 18.8306 4.44738C19.0232 4.75851 19.3383 4.91423 19.7754 4.91423H29.2246C29.9055 4.91423 30.507 5.13565 31.0291 5.5785C31.6762 6.11705 32 6.87418 32 7.84926C32 8.56154 31.7924 9.1958 31.3784 9.75235C30.8674 10.4346 30.1496 10.7758 29.2246 10.7758H17.2555V9.05208H29.2246C29.6617 9.05208 29.9768 8.89667 30.1694 8.58554C30.2431 8.47183 30.2973 8.33696 30.3312 8.18155C30.3536 8.07384 30.3653 7.96297 30.3653 7.84926C30.3653 7.38241 30.2176 7.04759 29.9226 6.84386C29.815 6.77216 29.6901 6.71814 29.5481 6.68245C29.4403 6.65844 29.3321 6.6436 29.2246 6.6376H19.7754C18.8561 6.6376 18.1377 6.29646 17.6216 5.61419C17.2073 5.06364 17 4.42938 17 3.7111C17 2.73602 17.3235 1.97889 17.9706 1.44002C18.4984 0.997495 19.0999 0.775757 19.7754 0.775757H31.7445V2.49944Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3809 6.00482V3.48024C47.3809 3.21055 47.291 2.98006 47.1112 2.78847C46.9311 2.59655 46.7149 2.50076 46.4618 2.50076H36.5379C36.2851 2.50076 36.0686 2.59655 35.8888 2.78847C35.7087 2.98006 35.6188 3.21055 35.6188 3.48024V6.00482H47.3809ZM35.6188 7.73013V10.7758H34V3.48024C34 2.73124 34.2471 2.09353 34.742 1.56617C35.2366 1.03912 35.8354 0.775757 36.5379 0.775757H46.4618C47.1646 0.775757 47.7631 1.03912 48.258 1.56617C48.7526 2.09353 49 2.73124 49 3.48024V10.7758H47.3809V7.73013H35.6188Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1538 9.05071V10.7758H55.8459C55.6109 10.7758 55.4112 10.692 55.2465 10.5241C55.0819 10.3566 55 10.1527 55 9.91339V7.84663C55 6.87647 55.3349 6.11874 56.0047 5.57344C56.5507 5.13657 57.1736 4.91782 57.8729 4.91782H67.1268C67.5792 4.91782 67.9054 4.76197 68.1048 4.4506C68.1811 4.33079 68.2372 4.19613 68.2722 4.04597C68.2958 3.93849 68.3076 3.82469 68.3076 3.70457C68.3076 3.24367 68.1547 2.91112 67.8493 2.70754C67.738 2.63578 67.6087 2.58173 67.4617 2.54569C67.3501 2.51597 67.2381 2.5008 67.1268 2.5008H55.8459V0.775757H67.1268C67.8316 0.775757 68.4546 0.994509 68.995 1.4317C69.6648 1.97668 70 2.73441 70 3.70457C70 4.42341 69.7851 5.06134 69.3563 5.61865C68.8276 6.30146 68.0843 6.64286 67.1268 6.64286H57.8815C57.7643 6.64286 57.6524 6.65487 57.5467 6.6789C57.4 6.71462 57.2676 6.77184 57.1504 6.8496C56.8447 7.05318 56.6921 7.38542 56.6921 7.84663V9.05071H69.1538Z",
    fill: "#FF7F00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_850_19369",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 1,
    width: 15,
    height: 10
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0371 1.00879H91.9171V10.6035H77.0371V1.00879Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_850_19369)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.9171 4.78988V8.01109C91.9171 8.72897 91.6689 9.34048 91.1733 9.84564C90.6827 10.3511 90.0892 10.6035 89.3927 10.6035H79.5533C78.8568 10.6035 78.263 10.3511 77.7727 9.84564C77.2824 9.34048 77.0371 8.72897 77.0371 8.01109V3.60139C77.0371 2.88958 77.2824 2.28079 77.7727 1.77533C78.263 1.26442 78.8568 1.00867 79.5533 1.00867H91.9089V2.6623H79.5533C79.3024 2.6623 79.088 2.75442 78.9095 2.93806C78.7312 3.122 78.6421 3.34291 78.6421 3.60139V8.01109C78.6421 8.26927 78.7312 8.49049 78.9095 8.67412C79.088 8.85806 79.3024 8.94988 79.5533 8.94988H89.3927C89.6436 8.94988 89.8577 8.85806 90.0362 8.67412C90.2145 8.49049 90.3039 8.26927 90.3039 8.01109V6.44352H89.7771V4.78988H91.9171Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_850_19369",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 1,
    width: 15,
    height: 10
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0176 1.00879H108.972V10.6036H94.0176V1.00879Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_850_19369)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.5917 6.69333V8.01121C95.5917 8.26939 95.6791 8.49061 95.8539 8.67424C96.029 8.85818 96.2393 8.95 96.4854 8.95H108.972V10.6036H96.4854C95.802 10.6036 95.2199 10.3509 94.739 9.84576C94.2582 9.34031 94.0176 8.72879 94.0176 8.01121V3.60121C94.0176 2.88939 94.2582 2.28061 94.739 1.77546C95.2199 1.26424 95.802 1.00879 96.4854 1.00879H108.972V2.66243H96.4854C96.2393 2.66243 96.029 2.75424 95.8539 2.93818C95.6791 3.12182 95.5917 3.34303 95.5917 3.60121V5.0397H108.972V6.69333H95.5917Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.381 3.47773C124.381 3.20833 124.291 2.97808 124.111 2.78668C123.931 2.59497 123.715 2.49927 123.462 2.49927H113.538C113.285 2.49927 113.068 2.59497 112.889 2.78668C112.708 2.97808 112.619 3.20833 112.619 3.47773V8.07378C112.619 8.34319 112.708 8.57375 112.889 8.76515C113.068 8.95686 113.285 9.05224 113.538 9.05224H123.462C123.715 9.05224 123.931 8.95686 124.111 8.76515C124.291 8.57375 124.381 8.34319 124.381 8.07378V3.47773ZM126 8.07378C126 8.822 125.753 9.45935 125.258 9.98585C124.763 10.5127 124.165 10.7758 123.462 10.7758H113.538C112.835 10.7758 112.236 10.5127 111.742 9.98585C111.247 9.45935 111 8.822 111 8.07378V3.47773C111 2.73584 111.247 2.10132 111.742 1.57482C112.236 1.04201 112.835 0.775757 113.538 0.775757H123.462C124.165 0.775757 124.763 1.04201 125.258 1.57482C125.753 2.10132 126 2.73584 126 3.47773V8.07378Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_850_19369",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 128,
    y: 1,
    width: 15,
    height: 11
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M128.059 1.02454H142.858V11.4522H128.059V1.02454Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_850_19369)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.742 6.24759C140.343 6.24759 140.775 6.00851 141.037 5.53033C141.13 5.36468 141.196 5.17477 141.234 4.96027C141.25 4.87454 141.261 4.79171 141.267 4.7118C141.278 4.64451 141.283 4.58012 141.283 4.51898C141.283 3.84442 141.07 3.3601 140.644 3.06601C140.496 2.96798 140.327 2.89454 140.135 2.84504C140.059 2.82692 139.985 2.81462 139.914 2.80848C139.854 2.80233 139.796 2.79618 139.742 2.79004H130.01C129.846 2.79004 129.736 2.84827 129.682 2.96474C129.66 3.00777 129.646 3.05371 129.641 3.10257L129.633 3.16727V6.24759H139.742ZM129.633 8.01309V11.2684H128.059V3.21321C128.059 2.4898 128.285 1.92589 128.739 1.52115C129.111 1.19018 129.534 1.02454 130.01 1.02454H139.742C140.502 1.02454 141.177 1.28821 141.767 1.81524C142.494 2.45907 142.858 3.36009 142.858 4.51898C142.858 5.37115 142.622 6.12789 142.152 6.79015C141.791 7.29907 141.343 7.64848 140.808 7.83839L142.292 9.60389L142.833 10.2383L141.693 11.4522L141.152 10.8178L139.266 8.58315L138.791 8.01309H129.633Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_850_19369",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 1,
    width: 15,
    height: 10
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M145.252 1.00879H159.846V10.6035H145.252V1.00879Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_850_19369)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.846 4.78988V8.01109C159.846 8.72897 159.602 9.34048 159.116 9.84564C158.635 10.3511 158.053 10.6035 157.37 10.6035H147.72C147.037 10.6035 146.454 10.3511 145.973 9.84564C145.493 9.34048 145.252 8.72897 145.252 8.01109V3.60139C145.252 2.88958 145.493 2.28079 145.973 1.77533C146.454 1.26442 147.037 1.00867 147.72 1.00867H159.838V2.6623H147.72C147.474 2.6623 147.263 2.75442 147.088 2.93806C146.913 3.122 146.826 3.34291 146.826 3.60139V8.01109C146.826 8.26927 146.913 8.49049 147.088 8.67412C147.263 8.85806 147.474 8.94988 147.72 8.94988H157.37C157.616 8.94988 157.826 8.85806 158.001 8.67412C158.176 8.49049 158.264 8.26927 158.264 8.01109V6.44352H157.747V4.78988H159.846Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_850_19369",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 180,
    height: 11
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.7758H180V0.775757H0V10.7758Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_850_19369)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162 10.7758H164V0.775757H162V10.7758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.381 6.00494V3.48013C178.381 3.2108 178.291 2.98035 178.111 2.78846C177.931 2.5969 177.715 2.5008 177.462 2.5008H167.538C167.285 2.5008 167.068 2.5969 166.889 2.78846C166.708 2.98035 166.619 3.2108 166.619 3.48013V6.00494H178.381ZM166.619 7.72998V10.7758H165V3.48013C165 2.73156 165.247 2.09364 165.742 1.56636C166.236 1.0394 166.835 0.775757 167.538 0.775757H177.462C178.165 0.775757 178.763 1.0394 179.258 1.56636C179.753 2.09364 180 2.73156 180 3.48013V10.7758H178.381V7.72998H166.619Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa2Logo);
export default __webpack_public_path__ + "static/media/usa2-logo.fcf63d5dc7afdb93f061f44f3d3f2fde.svg";
export { ForwardRef as ReactComponent };